<script>
  import { layoutMethods} from "@/state/helpers";
  import moment from 'moment-timezone';
  import Swal from 'sweetalert2';

  import { smartRaffleMethods } from "@/state/helpers"; // Import the methods for API connection

  // import Choices from "choices.js";

  /**
   * Prizes component
   */
  export default {
    page: {
      title: "Prizes"
    },
    components: {
    },
    computed: {
    },
    data() {
      return {
        title: "Prizes",
        prizeDetails: {
          prizeId: null,
          prizeName: null,
          raffleIdentifierId: null,
          countWinners: null,
          countBuffer: null,
          sequenceNumber: null,
        },
        prizeFormValidation: {
          raffleIdentifierId: false,
          prizeName: false,
          countWinners: false,
          sequenceNumber: false,
        },
        isSubmitted:false,
        isLoading: true,
        isAddMode: true,
        isEditMode: false,
        suggestedSeqNum: 0,
        prizeList: [],
        fieldsPrizeList: [
          { key: 'action', sortable: false },
          { key: 'prizeLimitStatus', sortable: false, label: 'Limit' },
          { key: 'raffleIdentifierName', sortable: true, label: 'Raffle Identifier Name' },
          { key: 'prizeName', sortable: true, label: 'Prize Name' },
          { key: 'prizeNumOfWinners', sortable: true, label: 'Number of Winners' },
          { key: 'prizeBufferNum', sortable: true, label: 'Buffer of Winner' },
          { key: 'prizeSequenceNum', sortable: true, label: 'Sequence' },
          { key: 'raffleDuration', sortable: true, label: 'Promo Date' },
          { key: 'raffleDrawDate', sortable: true, label: 'Draw Date' },
        ],
        raffleIdentifierList: [],
        raffleIdentifierDetails: {
          promoDuration: null,
          drawDate: null,
        },
        raffleIdentifierDropdown2: [
          { "value": 1, "label": "Smart Raffle Promo 1,000" },
          { "value": 2, "label": "Smart Raffle Promo 500" },
          { "value": 3, "label": "Smart Raffle Promo 300" },
          { "value": 4, "label": "Smart Raffle Promo 200" },
        ],

      };
    },
    methods: {
      ...layoutMethods,
      ...smartRaffleMethods,
      checkForm(mode) {
        let paramFormMode = mode;
        let status = true;

        this.prizeFormValidation.raffleIdentifierId = false;
        this.prizeFormValidation.prizeName = false;
        this.prizeFormValidation.countWinners = false;
        this.prizeFormValidation.sequenceNumber = false;

        if(this.isEmpty(this.prizeDetails.raffleIdentifierId) == true) {
          status = false;
          this.prizeFormValidation.raffleIdentifierId = true;
        }

        if(this.isEmpty(this.prizeDetails.prizeName) == true) {
          status = false;
          this.prizeFormValidation.prizeName = true;
        }

        if(this.isEmpty(this.prizeDetails.countWinners) == true) {
          status = false;
          this.prizeFormValidation.countWinners = true;
        }

        if(this.isEmpty(this.prizeDetails.sequenceNumber) == true) {
          status = false;
          this.prizeFormValidation.sequenceNumber = true;
        }

        if (status) {
          this.isSubmitted = true;

          if (paramFormMode == "add") {
            this.submitNewPrize();
          }
          else if (paramFormMode == "edit") {
            this.submitEditedPrize();
          }
        }

      },
      isEmpty(value){
        return (
        // null or undefined
        (typeof value == "undefined") || 
        (value == undefined) ||
        (value == null) ||
        (value === "") ||
        // has length and it's zero
        (Object.prototype.hasOwnProperty.call(value,'length') && value.length === 0) ||
        // is an Object and has no keys
        (value.constructor === Object && Object.keys(value).length === 0)
        )
      },
      checkChangedValue(data) {
        this.prizeFormValidation[data] = this.isEmpty(this.prizeDetails[data]);

        switch (data) {
          case "raffleIdentifierId": {
            let findData = this.raffleIdentifierList.find(x => 
              x.raffleIdentifierId == this.prizeDetails.raffleIdentifierId
            )

            // Refresh the values of dates, based on the selected Raffle Identifier in dropdown
            this.raffleIdentifierDetails.promoDuration = findData.raffleDuration
            this.raffleIdentifierDetails.drawDate = findData.raffleDrawDate
            break;
          }
        
          default:
            break;
        }
      },
      async submitNewPrize() {
        let requestPayload = {
          prizeName: this.prizeDetails.prizeName,
          prizeNumOfWinners: this.prizeDetails.countWinners,
          prizeBufferNum: this.prizeDetails.countBuffer,
          prizeSequenceNum: this.prizeDetails.sequenceNumber,
          raffleIdentifierId: this.prizeDetails.raffleIdentifierId
        }

        await this.actionSmartRaffle({
            action: "create-prize",
            body: { ...requestPayload }
        }).then((res) => {
          // Backend response
          let responseData = res["message"]

          if (responseData.statusCode == 201) {
            Swal.fire({
              title: "Duplicated Record!",
              html: `${responseData.message}`,
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: "#fff",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: 'btn-confirm',
              }
            }).then((result) => {
              if (result.isConfirmed) {
                this.isSubmitted = false
              }
            });
          }
          else { // If there's no duplicate Sequence Number, create new record successful
            Swal.fire({
              title: "Added Successful!",
              html: `<b>${this.prizeDetails.prizeName}</b> has been added.`,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#fff",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: 'btn-confirm',
              }
            }).then((result) => {
              if (result.isConfirmed) {
                this.isAddMode = true;
                this.isEditMode = false;
                this.getPrizeList();
                this.clearForm();
              }
            });
          }
          
        }).catch((err) => {
            console.error("err", err);
        })
        
      },
      async submitEditedPrize() {
        let requestPayload = {
          prizeId: this.prizeDetails.prizeId,
          prizeName: this.prizeDetails.prizeName,
          prizeNumOfWinners: this.prizeDetails.countWinners,
          prizeBufferNum: this.prizeDetails.countBuffer,
          prizeSequenceNum: this.prizeDetails.sequenceNumber,
          raffleIdentifierId: this.prizeDetails.raffleIdentifierId
        }

        await this.actionSmartRaffle({
            action: "update-prize",
            body: { ...requestPayload }
        }).then((res) => {
          // Backend Response
          let responseData = res["message"]

          if (responseData.statusCode == 201) {
            Swal.fire({
              title: "Duplicated Record!",
              html: `${responseData.message}`,
              icon: "warning",
              showCancelButton: false,
              confirmButtonColor: "#fff",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: 'btn-confirm',
              }
            }).then((result) => {
              if (result.isConfirmed) {
                this.isSubmitted = false
              }
            });
          }
          else { // If there's no duplicate Sequence Number, update record successful
            Swal.fire({
              title: "Update Successful!",
              html: `<b>${this.prizeDetails.prizeName}</b> has been updated.`,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#fff",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: 'btn-confirm',
              }
            }).then((result) => {
              if (result.isConfirmed) {
                this.isAddMode = true;
                this.isEditMode = false;
                this.getPrizeList();
                this.clearForm();
              }
            });
          }
          
        }).catch((err) => {
            console.error("err", err);
        })

      },
      editPrize(item) {
        this.isAddMode = false;
        this.isEditMode = true;

        let paramItem = item

        this.prizeDetails.prizeId = paramItem.prizeId
        this.prizeDetails.prizeName = paramItem.prizeName
        this.prizeDetails.raffleIdentifierId = paramItem.raffleIdentifierId
        this.prizeDetails.countWinners = paramItem.prizeNumOfWinners
        this.prizeDetails.countBuffer = paramItem.prizeBufferNum
        this.prizeDetails.sequenceNumber = paramItem.prizeSequenceNum

        this.raffleIdentifierDetails.promoDuration = paramItem.raffleDuration
        this.raffleIdentifierDetails.drawDate = paramItem.raffleDrawDate
      },
      cancelEditPrize() {
        this.isAddMode = true;
        this.isEditMode = false;
        this.clearForm();
      },
      deletePrize(item) {
        let paramItem = item

        let requestPayload = {
          "id": paramItem.prizeId
        }       

        Swal.fire({
          title: "Delete Prize?",
          html: `Are you sure you want to delete <b>${paramItem.prizeName}</b>?`,
          icon: "question",
          showCancelButton: true,
          cancelButtonText: "Cancel",
          confirmButtonColor: "#c4297c",
          cancelButtonColor: "#804997",
          confirmButtonText: "Confirm",
        }).then(async (result) => {
          if (result.isConfirmed) { //disabled successfully
            // Swal.fire("Success!", `Deleted successfully.`, "success");

            await this.actionSmartRaffle({
                action: "delete-prize",
                body: { ...requestPayload }
            }).then(() => {
              // Backend Response
              Swal.fire({
                title: "Success!",
                text: "Deleted successfully.",
                icon: "success",
                showCancelButton: false,
                confirmButtonColor: "#fff",
                confirmButtonText: "OK",
                customClass: {
                  confirmButton: 'btn-confirm',
                }
              }).then((result) => {
                if (result.isConfirmed) {
                  this.getPrizeList();
                }
              });
            }).catch((err) => {
                console.error("err", err);
            })
          }
        });

      },
      clearForm() {
        this.isSubmitted = false
        this.prizeDetails.raffleIdentifierId = null
        this.prizeDetails.prizeName = null
        this.prizeDetails.countWinners = null
        this.prizeDetails.countBuffer = null
        this.prizeDetails.sequenceNumber = null
      },
      formatDate(value){
        return moment(value).format('YYYY-MM-DD hh:mm A');
      },
      async updateLimitStatus(modalItem) {
        let requestPayload = {
          id: modalItem.prizeId,
          limitStatus: modalItem.prizeLimitStatus
        }   

        let action = (modalItem["prizeLimitStatus"] ? "Enable" : "Disable");

        if(action == "Disable"){ //disable the Limit
          Swal.fire({
            title: action + " Limit?",
            text: `Are you sure you want to disable the Limit?`,
            icon: "question",
            showCancelButton: true,
            cancelButtonText: "Cancel",
            confirmButtonColor: "#c4297c",
            cancelButtonColor: "#804997",
            confirmButtonText: "Confirm",
          }).then(async (result) => {
            if (result.isConfirmed) { //disabled successfully
              // Swal.fire("Success!", `${action}d successfully.`, "success");

              await this.actionSmartRaffle({
                  action: "update-prize-limit-status",
                  body: { ...requestPayload }
              }).then(() => {
                // Backend Response
                Swal.fire({
                  title: "Success!",
                  text: `${action}d successfully.`,
                  icon: "success",
                  showCancelButton: false,
                  confirmButtonColor: "#fff",
                  confirmButtonText: "OK",
                  customClass: {
                    confirmButton: 'btn-confirm',
                  }
                }).then((result) => {
                  if (result.isConfirmed) {
                    // this.getPrizeList();
                  }
                });
              }).catch((err) => {
                  console.error("err", err);
              })

            }
            else { //return to its previous status when "No" is selected
              modalItem["prizeLimitStatus"] = !modalItem["prizeLimitStatus"]
            }
          });
        }
        else { //Enable the Limit
          // Swal.fire("Success!", `${action}d successfully.`, "success");

          await this.actionSmartRaffle({
              action: "update-prize-limit-status",
              body: { ...requestPayload }
          }).then(() => {
            // Backend Response
            Swal.fire({
              title: "Success!",
              text: `${action}d successfully.`,
              icon: "success",
              showCancelButton: false,
              confirmButtonColor: "#fff",
              confirmButtonText: "OK",
              customClass: {
                confirmButton: 'btn-confirm',
              }
            }).then((result) => {
              if (result.isConfirmed) {
                // this.getPrizeList();
              }
            });
          }).catch((err) => {
              console.error("err", err);
          })

        }
      },
      async getRaffleIdentiferList() {
        await this.actionSmartRaffle({
            action: "active-raffle-identifier-list",
            body: { 
              hideExpiredPromo: true
            }
        }).then((res) => {
            // this.isLoading = false

            // this.raffleIdentifierList = res.message
            this.raffleIdentifierList = res["message"].map(raffle => { 
              return { 
                ...raffle,
                raffleDuration: raffle.raffleStartDate + " to " + raffle.raffleEndDate,
                value: raffle.raffleIdentifierId,
                text: raffle.raffleIdentifierName
              }
            });
            
        }).catch((err) => {
            console.error("err", err);
        })
      },
      async getPrizeList() {
        await this.actionSmartRaffle({
            action: "prize-list",
            // body: { draw: true }
        }).then((res) => {
            this.isLoading = false

            let backendResponse = res["message"]
            this.suggestedSeqNum = backendResponse["lastSequence"]
            this.prizeDetails.sequenceNumber = this.suggestedSeqNum + 1

            this.prizeList = backendResponse["data"].map(prize => { 
              return { 
                ...prize,
                raffleDuration: prize.raffleStartDate + " to " + prize.raffleEndDate,
              }
            });
            
        }).catch((err) => {
            console.error("err", err);
        })
      },
    },
    async mounted(){
      // new Choices("#choices-raffle-identifier", {
      //   placeholder: true,
      //   placeholderValue: "Placeholder",
      //   searchPlaceholderValue: "Search Raffle Identifier",
      //   renderSelectedChoices: null
      // });

      this.getRaffleIdentiferList();
      this.getPrizeList();

    }
  }
    
</script>



<template>
  <div class="row"><!-- outer div-->
    <div class="col-md-5 col-12" v-if="isAddMode"> <!-- start of Add Prizes main div -->
      <div class="card">
        <div class="card-header text-dark fw-bold">
          Add Prizes
        </div>
        <div class="card-body">
          <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form @submit.prevent="handleSubmit(checkForm('add'))"
                    @reset.prevent="reset">
              
              <div class="col-md-12">
                <label class="form-label small fw-bold">Raffle Identifier Name <span style="color: red">*</span></label>
                <template>
                  <b-form-select v-model="prizeDetails.raffleIdentifierId" 
                                  :options="raffleIdentifierList" 
                                  class="form-select shadow-none"
                                  :class="{
                                      'is-invalid' : prizeFormValidation.raffleIdentifierId
                                  }"
                                  @change="checkChangedValue('raffleIdentifierId')">
                    <template #first>
                      <b-form-select-option :value="null" 
                                            disabled>
                        Select Raffle Identifier
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </template>
                <div v-if="prizeFormValidation.raffleIdentifierId"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of raffleIdentifierId field -->

              <div class="col-md-12 mt-4" v-if="prizeDetails.raffleIdentifierId != null">
                <label>
                  <span>Promo Date:</span><br>
                  <span>{{ raffleIdentifierDetails.promoDuration }}</span>
                </label><br>
                <label>
                  <span>Draw Date:</span><br>
                  <span>{{ formatDate(raffleIdentifierDetails.drawDate) }}</span>
                </label>
              </div>

              <!-- <b-form-group class="">
                <label class="form-label small fw-bold">Raffle Identifier Name <span style="color: red">*</span></label>
                <validation-provider name="raffle identifier" 
                                     rules="required" 
                                     v-slot="validationContext">
                  <select class="form-control"
                          v-model="prizeDetails.raffleIdentifierId" 
                          id="choices-raffle-identifier" 
                          :state="getValidationState(validationContext)" 
                          data-trigger>
                    <option value="null" disabled>Select Raffle Identifier</option>
                    <option v-for="raffle in raffleIdentifierDropdown2" 
                              :value="raffle.value"
                              v-bind:key="raffle.label">{{ raffle.label }}</option>
                  </select>
                </validation-provider>
              </b-form-group> -->

              <div class="col-md-12 mt-3">
                <label>Prize Name <span class="text-danger">*</span></label>
                <b-form-input placeholder="Enter Prize Name"
                              v-model="prizeDetails.prizeName"
                              class="form-control"
                              :class="{
                                  'is-invalid' : prizeFormValidation.prizeName
                              }"
                              @change="checkChangedValue('prizeName')"
                              trim
                ></b-form-input>
                <div v-if="prizeFormValidation.prizeName"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of prizeName field -->

              <div class="col-md-12 mt-3">
                <label>Number of Winners <span class="text-danger">*</span></label>
                <b-form-input placeholder="Enter Number of Winners"
                              v-model="prizeDetails.countWinners"
                              class="form-control"
                              type="number"
                              min="1"
                              :class="{
                                  'is-invalid' : prizeFormValidation.countWinners
                              }"
                              @change="checkChangedValue('countWinners')"
                              trim
                ></b-form-input>
                <div v-if="prizeFormValidation.countWinners"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of countWinners field -->

              <div class="col-md-12 mt-3">
                <label>Number of Buffer Winners</label>
                <b-form-input placeholder="Enter Number of Buffer"
                              v-model="prizeDetails.countBuffer"
                              type="number"
                              min="0"
                              trim
                ></b-form-input>
              </div> <!-- End of countBuffer field -->

              <div class="col-md-12 mt-3">
                <label>Sequence Number <span class="text-danger">*</span></label>
                <b-form-input placeholder="Enter Sequence Number"
                              v-model="prizeDetails.sequenceNumber"
                              class="form-control"
                              type="number"
                              min="1"
                              :class="{
                                  'is-invalid' : prizeFormValidation.sequenceNumber
                              }"
                              @change="checkChangedValue('sequenceNumber')"
                              trim
                ></b-form-input>
                <div v-if="prizeFormValidation.sequenceNumber"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of sequenceNumber field -->

              <div class="mt-4">
                <b-button class="w-100"
                          type="submit"
                          variant="primary"
                          :disabled="isSubmitted">
                  <span v-if="isSubmitted"
                        class="spinner-grow spinner-grow-sm"
                        role="status"
                        aria-hidden="true"
                  ></span>
                  Add
                </b-button>
              </div> <!-- End of ADD button -->

            </b-form>
          </ValidationObserver>
        </div>
      </div>
    </div> <!-- end of Add Prizes main div -->


    <div class="col-md-5 col-12" v-if="isEditMode"> <!-- start of Ediit Prizes main div -->
      <div class="card">
        <div class="card-header text-dark fw-bold">
          Edit Prizes
        </div>
        <div class="card-body">
          <ValidationObserver v-slot="{ handleSubmit, reset }">
            <b-form @submit.prevent="handleSubmit(checkForm('edit'))"
                    @reset.prevent="reset">

              <div class="col-md-12">
                <label class="form-label small fw-bold">Raffle Identifier Name <span style="color: red">*</span></label>
                <template>
                  <b-form-select v-model="prizeDetails.raffleIdentifierId" 
                                  :options="raffleIdentifierList" 
                                  class="form-select shadow-none"
                                  :class="{
                                      'is-invalid' : prizeFormValidation.raffleIdentifierId
                                  }"
                                  @change="checkChangedValue('raffleIdentifierId')">
                    <template #first>
                      <b-form-select-option :value="null" 
                                            disabled>
                        Select Raffle Identifier
                      </b-form-select-option>
                    </template>
                  </b-form-select>
                </template>
                <div v-if="prizeFormValidation.raffleIdentifierId"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of raffleIdentifierId field -->

              <div class="col-md-12 mt-4" v-if="prizeDetails.raffleIdentifierId != null">
                <label>
                  <span>Promo Date:</span><br>
                  <span>{{ raffleIdentifierDetails.promoDuration }}</span>
                </label><br>
                <label>
                  <span>Draw Date:</span><br>
                  <span>{{ formatDate(raffleIdentifierDetails.drawDate) }}</span>
                </label>
              </div>

              <div class="col-md-12 mt-3">
                <label>Prize Name <span class="text-danger">*</span></label>
                <b-form-input placeholder="Enter Prize Name"
                              v-model="prizeDetails.prizeName"
                              class="form-control"
                              :class="{
                                  'is-invalid' : prizeFormValidation.prizeName
                              }"
                              @change="checkChangedValue('prizeName')"
                              trim
                ></b-form-input>
                <div v-if="prizeFormValidation.prizeName"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of prizeName field -->

              <div class="col-md-12 mt-3">
                <label>Number of Winners <span class="text-danger">*</span></label>
                <b-form-input placeholder="Enter Number of Winners"
                              v-model="prizeDetails.countWinners"
                              class="form-control"
                              type="number"
                              min="1"
                              :class="{
                                  'is-invalid' : prizeFormValidation.countWinners
                              }"
                              @change="checkChangedValue('countWinners')"
                              trim
                ></b-form-input>
                <div v-if="prizeFormValidation.countWinners"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of countWinners field -->

              <div class="col-md-12 mt-3">
                <label>Number of Buffer Winners</label>
                <b-form-input placeholder="Enter Number of Buffer"
                              v-model="prizeDetails.countBuffer"
                              type="number"
                              min="0"
                              trim
                ></b-form-input>
              </div> <!-- End of countBuffer field -->

              <div class="col-md-12 mt-3">
                <label>Sequence Number <span class="text-danger">*</span></label>
                <b-form-input placeholder="Enter Sequence Number"
                              v-model="prizeDetails.sequenceNumber"
                              class="form-control"
                              type="number"
                              min="1"
                              :class="{
                                  'is-invalid' : prizeFormValidation.sequenceNumber
                              }"
                              @change="checkChangedValue('sequenceNumber')"
                              trim
                ></b-form-input>
                <div v-if="prizeFormValidation.sequenceNumber"
                     class="invalid-feedback">
                     This field is required
                </div>
              </div> <!-- End of sequenceNumber field -->

              <div class="row mt-4">
                <div class="col-md-6">
                  <b-button class="w-100"
                            type="submit"
                            variant="primary"
                            :disabled="isSubmitted">
                    <span v-if="isSubmitted"
                          class="spinner-grow spinner-grow-sm"
                          role="status"
                          aria-hidden="true"
                    ></span>
                    Update
                  </b-button>
                </div> <!-- End of UPDATE button -->

                <div class="col-md-6">
                  <b-button class="w-100"
                            type="button"
                            variant="light"
                            :disabled="isSubmitted"
                            @click="cancelEditPrize">
                    Cancel
                  </b-button>
                </div> <!-- End of CANCEL button -->
              </div> 

            </b-form>
          </ValidationObserver>
        </div>
      </div>
    </div> <!-- end of Ediit Prizes main div -->


    <div class="col-md-7 col-12"> <!-- start of Prize List main div -->
      <div class="card">
        <div class="card-header text-dark fw-bold">
          Prize List ({{ prizeList.length }})
        </div>
        <div class="card-body">
          <div class="table-responsive"> <!-- start of Prize List data-table -->
            <div class="table align-middle table-nowrap">
              <b-table :items="prizeList"
                       :fields="fieldsPrizeList"
                       responsive="sm"
                       class="table-check">

                <template #cell(action)="data">
                  <div class="d-flex">
                    <div class="btn-group me-2 mb-2 mb-sm-0">
                      <button type="button" 
                              class="btn btn-sm btn-primary p-1"
                              @click="editPrize(data.item)">
                              <i class="bx bx-edit bx-xs bx-fw"></i>
                      </button>
                    </div>
                    <div>
                      <b-button id="show-btn" 
                                class="btn btn-sm btn-danger p-1"
                                @click="deletePrize(data.item)"
                                :disabled="data.item.transactionCount > 0">
                                <i class="bx bx-trash bx-xs bx-fw"></i>
                      </b-button>
                    </div>
                  </div>
                </template>

                <template #cell(prizeLimitStatus)="data">
                  <div class="form-check form-switch form-switch-lg">
                    <input class="form-check-input mt-1"
                           v-model="data.item.prizeLimitStatus"
                           type="checkbox"
                           id="flexSwitchCheckDefault"
                           @change="updateLimitStatus(data.item)" />
                  </div>
                </template>

                <template #cell(raffleIdentifierName)="data">
                  <span>{{ data.item.raffleIdentifierName }}</span>
                </template>

                <template #cell(prizeName)="data">
                  <p class="text-body m-0 ">{{ data.item.prizeName }}</p>
                </template>
                
                <template #cell(raffleDrawDate)="data">
                  <p class="text-body m-0 ">{{ formatDate(data.item.raffleDrawDate) }}</p>
                </template>


              </b-table>
            </div>
          </div> <!-- end of Prize List data-table -->

          <div class="row g-0 mb-1 text-center" v-if="isLoading">
            <span>Loading data...</span>
          </div>
          <div class="row g-0 text-center" v-if="!isLoading && prizeList.length == 0">
            <span>No data to display.</span>
          </div>


        </div>
      </div>
    </div> <!-- end of Prize List main div -->
  </div> <!-- end of outer div-->
</template>



<style>
  .form-check-input {
    &:checked {
      background-color: #E73092;
      border-color: #E73092;
    }
  }
</style>